export default class Schools {
    constructor() {
        this.schoolInfoBtn = document.querySelector('#schoolInfoBtn');
        this.seniorInfoBtn = document.querySelector('#seniorInfoBtn');
        this.pricelistsBtn = document.querySelector('#pricelistsBtn');
        this.schoolInfoContainer = document.querySelector('#schoolInfoContainer');
        this.seniorInfoContainer = document.querySelector('#seniorInfoContainer');
        this.pricelistsContainer = document.querySelector('#pricelistsContainer');
        
        // add event listeners
        schoolInfoBtn.addEventListener('click', this.showSchoolInfo)
        seniorInfoBtn.addEventListener('click', this.showSeniorInfo)
        pricelistsBtn.addEventListener('click', this.showPricelistInfo)
    }

    // show/hide methods

    static deselectButton(button) {
        if (button.children[0].classList.contains('active')) {
            button.children[0].classList.toggle('active')
        }

    }

    static deselectAll() {
        const editSchoolBtns = [
            schoolInfoBtn, 
            seniorInfoBtn, 
            pricelistsBtn
        ];
        editSchoolBtns.forEach((button) => this.deselectButton(button))
    }

    static hideContainer(container) {
        if (!container.classList.contains('hidden')) {
            container.classList.toggle('hidden')
        }
    }

    static hideAll() {
        const editSchoolContainers = [
            schoolInfoContainer, 
            seniorInfoContainer, 
            pricelistsContainer
        ];
        editSchoolContainers.forEach((container) => this.hideContainer(container))
    }

    static inputSelection() {
        this.hideAll()
        this.deselectAll()
    }

    showSchoolInfo() {
        Schools.inputSelection()
        this.children[0].classList.toggle('active')
        schoolInfoContainer.classList.toggle('hidden')
    }

    showSeniorInfo = () => {
        Schools.inputSelection()
        seniorInfoBtn.children[0].classList.toggle('active')
        seniorInfoContainer.classList.toggle('hidden');
    }

    showPricelistInfo() {
        Schools.inputSelection()
        this.children[0].classList.toggle('active')
        pricelistsContainer.classList.toggle('hidden')
    }
} 
